'use client';

import { downloadFile } from '@/shared/utils/download';
import { buildOrderUrl, getOrderBaseUrl } from '@/shared/utils/order.utils';
import { useRichTextLanguage } from '../RichTextElementsContext';

import type { FileCardAttrs } from './fileCard.types';
import { FileCardButton } from './layouts/FileCardButton';
import { FileCardDefault } from './layouts/FileCardDefault';
import { FileCardSample } from './layouts/FileCardSample';

type Props = {
  attrs: FileCardAttrs;
};

/**
 * FileCard — renders a downloadable file card inside article content.
 * Delegates to layout-specific components based on `attrs.layout`.
 *
 * Used by RichText component map for `<file-card>` custom HTML elements.
 */
export const FileCard = ({ attrs }: Props) => {
  const isGerman = useRichTextLanguage() === 'de';

  const handleDownload = () => {
    if (attrs.url) downloadFile(attrs.url, (attrs.title || 'download') + (attrs.ext || ''));
  };

  // Button layout — inline download button, no card chrome
  if (attrs.layout === 'button') {
    return <FileCardButton attrs={attrs} orderBaseUrl={null} onOrder={() => {}} onDownload={handleDownload} />;
  }

  const orderBaseUrl = attrs.withOrderForm ? getOrderBaseUrl(undefined, isGerman) : null;
  const orderFullUrl = attrs.withOrderForm ? buildOrderUrl(attrs, undefined, isGerman) : null;

  const handleOrder = () => {
    if (orderFullUrl) {
      console.log(`[FileCard] Order similar (${isGerman ? 'DE' : 'EN'}):`, orderFullUrl);
      window.location.href = orderFullUrl;
    }
  };

  const Layout = attrs.layout === 'sample' ? FileCardSample : FileCardDefault;

  return <Layout attrs={attrs} orderBaseUrl={orderBaseUrl} onOrder={handleOrder} onDownload={handleDownload} />;
};
